import React, { useContext, useRef, useState } from "react";
import "./Projects.css";
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";
import { Theme } from "../App";
import ImageCrousel from "./ImageCrousel";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";


const projects = [
  {
    projectHeading: "Clique",
    projectImg: ["/Clique1.png", "/Clique2.png", "/Clique3.png"],
    appLink: "https://clique-chat-app.vercel.app/",
    codeLink: "https://github.com/Ali-Ishaq",
    projectParagraph: `Clique is a chat app built using the MERN stack (MongoDB, Express.js, React, Node.js) and Socket.io, designed to offer a seamless real-time messaging experience. The app allows users to create accounts, add friends, and form groups for communication. Real-time message delivery and live updates are powered by Socket.io, ensuring instant interactions and efficient communication.
    The intuitive interface makes it easy for users to stay connected, with dynamic features such as online status indicators and unread message counts. Clique also includes a powerful search function, enabling users to quickly find others by username. Through building this app, I gained hands-on experience in full-stack development, real-time communication, and optimizing user interactions in a dynamic web application.`,
  },
  {
    projectHeading: "Outliers Clothing",
    projectImg: ["/outliers.png", "/outliers.png", "/outliers.png"],
    appLink: "https://outliers-clothing.vercel.app/",
    codeLink: "https://github.com/Ali-Ishaq",
    projectParagraph: `Outliers Clothing is a robust e-commerce platform built on the MERN stack (MongoDB, Express.js,    React, Node.js), offering a comprehensive shopping experience. The app features product listings, user authentication, shopping cart functionality, and order management. It also includes an intuitive admin panel for easy product management and inventory updates, streamlining store operations.The user interface is modern and responsive, ensuring a seamless experience across both desktop and mobile devices. It provides a real-time inventory management ensures product availability is always accurate.With a focus on user experience, Outliers Clothing delivers a platform that is easy to navigate, secure, and efficient for both shoppers and store managers, providing a smooth and enjoyable e-commerce experience.`,
  },
  {
    projectHeading: "ToonTales Animation",
    projectImg: ["/toontales.png", "/toontales.png", "/toontales.png"],
    appLink: "https://toontalesanimation.com/",
    codeLink: "https://github.com/Ali-Ishaq",
    projectParagraph: `A dynamic portfolio website for ToonTales Animation, an animation studio, developed using React for a fast and interactive user experience. The website features a visually appealing and responsive design to showcase the studio’s diverse portfolio of animated projects. Key features include:
    Interactive Gallery: A showcase of ToonTales’ animation work with smooth transitions and engaging visuals.
    Responsive Design: Optimized for both desktop and mobile devices for accessibility across platforms.
    React Components: Utilized React’s reusable components for a clean, maintainable codebase and fast load times.
    This project helped me hone my skills in React, front-end development, and user experience design while creating a functional platform for ToonTales Animation.`,
  },
  {
    projectHeading: "Weather App",
    projectImg: ["/weatherapp.png", "/weatherapp.png", "/weatherapp.png"],
    appLink: "https://weather-app-phi-gules-13.vercel.app/",
    codeLink: "https://github.com/Ali-Ishaq",
    projectParagraph: `A simple weather web app built using React, designed to provide users with real-time weather information. The app features a search functionality, allowing users to easily look up weather data for any location. With a clean and intuitive user interface, the app presents weather details such as temperature, humidity, and wind speed in a visually appealing format. The responsive design ensures a smooth experience on both desktop and mobile devices, making it easy for users to access accurate weather information wherever they are.
    I built this app to improve my skills in React and enhance my understanding of working with APIs. Through this project, I learned how to manage state, handle user inputs, and dynamically display data from external sources. It also gave me the opportunity to focus on building a clean, user-friendly interface that prioritizes both functionality and design, creating a smooth and engaging experience for users.`,
  },
];

const ParagraphStyle = {
  WebkitLineClamp: "none",
  WebkitBoxOrient: "horizontal",
  overflow: "visible",
  display: "block",
};

function Projects() {

  const { theme } = useContext(Theme);
  // const [isTextVisible, setIsTextVisible] = useState(false);
  const [isTextVisible, setIsTextVisible] = useState(Array(projects.length).fill(false));

  return (
    <div id="projects-comp" className={`projects-comp projects-comp-${theme}`}>
      <h1 className="project-heading">Porfolio</h1>
      <p>
        " Step into my digital playground and explore a collection of innovative
        web projects. From vibrant designs to seamless functionality, each one
        tells a story of creativity and ingenuity.
        <span style={{ fontSize: "22px",position:'absolute' }}>🚀 "</span> 
      </p>
      <div className="projects">
        {projects.map((elem, index) => {
          return (
            <div className="project">
              <section
                className="project-img"
                style={index % 2 != 0 && index != 0 ? { order: "1" } : {}}
              >
                <h1 className="project-heading-mobile">
                  <span style={{ color: "#10a37f" }}>{`${index + 1}. `}</span>
                  {elem.projectHeading}
                </h1>
                {/*<img src={elem.projectImg} alt="" /> */}

                <ImageCrousel images={elem.projectImg}></ImageCrousel>
              </section>

              <section className="project-description">
                <h1>
                  <span style={{ color: "#10a37f" }}>{`${index + 1}. `}</span>
                  {elem.projectHeading}
                </h1>

                <span>
                  <p className="project-pragraph">{elem.projectParagraph}</p>
                  <p
                    style={isTextVisible[index] ? ParagraphStyle : null}
                    className="project-pragraph-mobile"
                  >
                    {elem.projectParagraph}
                  </p>

                  <p
                    onClick={() =>{

                      setIsTextVisible((prev) => {
                        const newVisibility = [...prev];
                        newVisibility[index] = !newVisibility[index];
                        return newVisibility;
                      })

                        
                    }
                    }
                    className="showTextBtn"
                  >
                    {isTextVisible[index] ? "View Less" : "View More" }
                    <MdOutlineKeyboardArrowDown size={'25px'} style={isTextVisible[index] ?{rotate:'0 0 1 180deg',transition:'0.3s'}:{rotate:'0 0 1 0deg',transition:'0.3s'}}/>
                  </p>
                </span>
                <div className="code-visit">
                  <a
                    target="_blank"
                    href={elem.codeLink}
                    style={{
                      textDecoration: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <p>Code </p>
                    <FaGithub
                      size={"30px"}
                      color={theme === "light" ? "#2d2e32" : "f9f9f9"}
                    />
                  </a>
                  <a
                    href={elem.appLink}
                    target="_blank"
                    style={{
                      textDecoration: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <p>Live Demo </p>
                    <FaExternalLinkAlt
                      size={"25px"}
                      color={theme === "light" ? "#2d2e32" : "f9f9f9"}
                    />
                  </a>
                </div>
              </section>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Projects;
